module.exports = __webpack_public_path__ + "resources/88e786abf37816f77eb93b1e642c5d52.png";